var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenditRopeStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 100,
    viewBox: "0 0 147 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_147",
    "data-name": "\\uC0AC\\uAC01\\uD615 147",
    width: 147,
    height: 100,
    transform: "translate(567 1083)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_5",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 5",
    transform: "translate(-567 -1083)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_738",
    "data-name": "\\uADF8\\uB8F9 738",
    transform: "translate(-56 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_735",
    "data-name": "\\uADF8\\uB8F9 735",
    transform: "translate(622.518 1117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    transform: "translate(0 0.98)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16",
    "data-name": "\\uD328\\uC2A4 16",
    d: "M160.477,176.844,138.106,138.1a25.012,25.012,0,0,1,9.154-34.169h0l26.952,46.678Z",
    transform: "translate(-102.239 -77.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M0,.26H44.741A25.01,25.01,0,0,1,69.753,25.275l-53.9,0Z",
    transform: "translate(0 -0.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_18",
    "data-name": "\\uD328\\uC2A4 18",
    d: "M294.415.014,270.441,37.792a25.01,25.01,0,0,1-34.521,7.721h0L264.8,0Z",
    transform: "translate(-179)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    transform: "translate(175.17 99.02) rotate(180)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    d: "M25.726,72.914,3.356,34.169A25.012,25.012,0,0,1,12.51,0h0L39.462,46.678Z",
    transform: "translate(32.511 26.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_20",
    "data-name": "\\uD328\\uC2A4 20",
    d: "M0,0H44.741A25.01,25.01,0,0,1,69.753,25.015l-53.9,0Z",
    transform: "translate(0 0.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_21",
    "data-name": "\\uD328\\uC2A4 21",
    d: "M58.5.014,34.521,37.792A25.01,25.01,0,0,1,0,45.513H0L28.882,0Z",
    transform: "translate(56.92 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_736",
    "data-name": "\\uADF8\\uB8F9 736",
    transform: "translate(743.518 1117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-3",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    transform: "translate(0 0.98)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17-2",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M0,.26H44.741A25.01,25.01,0,0,1,69.753,25.275l-53.9,0Z",
    transform: "translate(0 -0.197)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenditRopeStart);
export default __webpack_public_path__ + "static/media/vendit_rope_start.ec3b0470.svg";
export { ForwardRef as ReactComponent };